import { FormsMultilineInput } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

/**
 * The optional "+ Add a note" free-text field shown on the confirmation-style screens
 * (scheduled / still deciding / matched elsewhere / unresponsive). Optional, 500-char limit.
 */
export const OptionalNote = (props: {
  control: Control<UpdateDiscoveryCallFormData>;
  placeholder?: string;
}) => {
  return (
    <div className='mt-4 w-full items-stretch'>
      <div className='text-sm'>
        Anything you'd like to share with the MovingWorlds team? (optional)
      </div>
      <FormsMultilineInput
        control={props.control}
        name='additionalDetails'
        characterCount={500}
        placeholder={props.placeholder ?? 'Enter details'}
      />
    </div>
  );
};
